export default "__VITE_PUBLIC_ASSET__1e8147b6__"